import { Skeleton } from 'antd';
import { isObject } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import {
  CpFooterWithLinkGroupOnBottomLinkGroupSection,
  CpFooterWithLinkGroupOnBottomLinkGroup,
} from 'components/organisms/customer-portal/widgets/footer/variants/cp-footer-with-link-group-on-bottom';
import {
  CpFooterSectionWrapper,
  CpFooterWithoutLinkGroupsLinksWrapper,
  CpFooterWithoutLinkGroupsWrapper,
} from 'components/organisms/customer-portal/widgets/footer/variants/cp-footer-without-link-groups';
import { CpLoadingProps } from '../common';

const GroupTitle = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton,
  & {
    max-width: 100% !important;
    width: 200px !important;
    height: 24px !important;
    margin-bottom: var(--cp-spacing-04);
  }

  &.ant-skeleton-button,
  .ant-skeleton-button {
    border-radius: var(--border-radius-default);
    height: 100% !important;
    width: 100% !important;
  }
`;
const Item = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton,
  & {
    max-width: 100% !important;
    width: 150px !important;
    height: 20px !important;
    margin-bottom: var(--cp-spacing-02);
  }

  &.ant-skeleton-button,
  .ant-skeleton-button {
    border-radius: var(--border-radius-default);
    height: 100% !important;
    width: 100% !important;
  }
`;

export const Content: React.FC<{
  variantType: string;
  input: Record<string, unknown>;
}> = ({ variantType, input }) => {
  switch (variantType) {
    case CpWidgetVariantType.FooterWithoutLinkGroups:
    case undefined:
      return (
        <CpFooterWithoutLinkGroupsWrapper>
          <CpFooterWithoutLinkGroupsLinksWrapper>
            <Item active />
            <Item active />
          </CpFooterWithoutLinkGroupsLinksWrapper>
        </CpFooterWithoutLinkGroupsWrapper>
      );

    case CpWidgetVariantType.FooterWithLinkGroupOnBottom:
      return (
        <CpFooterWithLinkGroupOnBottomLinkGroupSection>
          {((input?.footerColumns as unknown[]) ?? [1, 2, 3])?.map((fc) => (
            <CpFooterWithLinkGroupOnBottomLinkGroup>
              <GroupTitle active />
              {(isObject(fc)
                ? ((fc as any)?.footerItems as unknown[]) ?? [1, 2, 3]
                : [1, 2, 3]
              )?.map(() => (
                <Item active />
              ))}
            </CpFooterWithLinkGroupOnBottomLinkGroup>
          ))}
        </CpFooterWithLinkGroupOnBottomLinkGroupSection>
      );

    default:
      return <></>;
  }
};

export const CpFooterLoading: React.FC<CpLoadingProps> = ({
  input,
  variantType,
  styles,
}) => {
  return (
    <CpFooterSectionWrapper
      background={styles?.background as string}
      paddingY={styles?.paddingY as number | undefined}
      className="!cp-max-w-none"
    >
      <Content variantType={variantType} input={input} />
    </CpFooterSectionWrapper>
  );
};
